import { create } from 'zustand'
import { MenuItem } from '@src/api/common/menu'
import { IconMap } from '@src/utils/common/iconMap'
import { fetcher } from '@src/utils/fetcher'

// 后端返回的菜单项类型（可选，用于类型安全）
interface ApiMenu {
	id: number
	parentMenuId: number
	textKey: string
	iconName: string | null
	menuPath: string | null
	orderNum: number
	hideMenu: boolean
	children: ApiMenu[] | null
}

interface MenuState {
	menuList: MenuItem[]
	loading: boolean
	loaded: boolean
	fetchMenuList: () => Promise<void>
}

const useMenuStore = create<MenuState>((set, get) => ({
	menuList: [],
	loading: false,
	loaded: false,

	fetchMenuList: async () => {
		set({ loading: true })
		try {
			const res = await fetcher<{ data: ApiMenu[] }>('/sys/usermenu', 'GET')
			const converted = convertApiMenuToMenuItem(res.data)
			set({ menuList: converted, loaded: true })
		} catch (err) {
			// 可选：设置空菜单或兜底
			set({ menuList: [], loaded: true })
		} finally {
			set({ loading: false })
		}
	}
}))

/**
 * 将 API 返回的菜单树转换为前端 MenuItem 格式
 */
export function convertApiMenuToMenuItem(apiMenus: ApiMenu[]): MenuItem[] {
	return apiMenus
		.map((item) => {
			const converted: MenuItem = {
				itemKey: String(item.id), // 转为字符串，匹配原有 '1', '1-1' 风格
				text: item.textKey, // i18n key，如 'app.menu.dashboard'
				hide: item.hideMenu,
				path: item.menuPath || undefined, // null 或空字符串转为 undefined
				icon: item.iconName ? IconMap[item.iconName] : undefined,
				items: item.children ? convertApiMenuToMenuItem(item.children) : undefined
			}
			return converted
		})
		.sort((a, b) => {
			// 可选：按 orderNum 排序（如果后端未排序）
			// 但你的数据已按 orderNum 排好，可省略
			return 0
		})
}

export default useMenuStore
